export const BORDER_WIDTH = 2;
export const COLUMNS = 16;
export const FOOT_WIDTH = 164;
export const FOOT_HEIGHT = 324;
export const FOOT_ONLY_WIDTH = 246;
export const FOOT_ONLY_HEIGHT = 486;
export const ROWS = 32;
